module.exports = __webpack_public_path__ + "img/盲盒.0d248576.png";